<div class="grid" [ngClass]="layout">
  <ng-content />
</div>

<div *ngIf="isEmptyLayout" class="overlay" @fadeInOut>
  <mat-spinner />
</div>
